import api from './api';

export const donationService = {
  getAll: (params?: any) => api.get('/donations', { params }),
  getById: (id: number) => api.get(`/donations/${id}`),
  create: (data: any) => api.post('/donations', data),
  update: (id: number, data: any) => api.put(`/donations/${id}`, data),
  delete: (id: number) => api.delete(`/donations/${id}`),
  confirm: (id: number) => api.post(`/donations/${id}/confirm`),
  useForTuition: (id: number, data: any) => api.post(`/donations/${id}/use-for-tuition`, data),
  getStats: (params?: any) => api.get('/donations/stats', { params })
};